module.exports = __webpack_public_path__ + "static/media/ico_refresh_o.109de09f.svg";